export function blendWithWhite(hex: string, brightness = 0.9) {
  hex = hex.replace('#', '')

  if (hex.length === 3) {
    hex = hex.split('').map(c => c + c).join('')
  }

  const r = parseInt(hex.slice(0, 2), 16)
  const g = parseInt(hex.slice(2, 4), 16)
  const b = parseInt(hex.slice(4, 6), 16)

  const mix = (channel: number) =>
    Math.round(channel * brightness + 255 * (1 - brightness))

  const toHex = (value: number) =>
    value.toString(16).padStart(2, '0')

  return `#${toHex(mix(r))}${toHex(mix(g))}${toHex(mix(b))}`
}